import 'theme/overrides.scss';

import { ConfigProviderProps } from 'antd';
import frFR from 'antd/locale/fr_FR';
import theme from 'theme/theme.json'; // à modifier dans https://ant.design/theme-editor

const appTheme: ConfigProviderProps = {
  locale: frFR,
  theme,
  card: {
    className: ' border-none shadow-xs shadow-slate-10 px-4 py-6',
  },
  drawer: {
    styles: {
      wrapper: { background: theme.token.colorBgContainer },
      content: { background: theme.token.colorBgContainer },
      header: {
        background: theme.token.colorPrimary,
        borderBottom: 'none',
        padding: '16px 24px',
      },
      body: { background: theme.token.colorBgContainer },
      footer: {
        background: theme.token.colorBgContainer,
        borderTop: '1px solid rgba(0, 0, 0, 0.06)',
        padding: '12px 24px',
      },
    },
  },
};

export const LEADS_DRAWER_STYLES = {
  wrapper: { background: theme.token.colorBgContainer },
  content: { background: theme.token.colorBgContainer },
  header: {
    background: theme.token.colorPrimary,
    borderBottom: 'none',
    padding: '16px 24px',
  },
  body: { background: theme.token.colorBgContainer },
  footer: {
    background: theme.token.colorBgContainer,
    borderTop: '1px solid rgba(0, 0, 0, 0.06)',
    padding: '12px 24px',
  },
} as const;

/**
 * Formulaires des volets latéraux leads : libellés en gras, y compris ceux des
 * champs facultatifs (AntD ne met en gras que les labels `required`).
 */
export const LEADS_DRAWER_FORM_CLASS =
  'flex flex-col gap-1 [&_.ant-form-item]:mb-3 [&_label]:font-bold';

export default appTheme;
